import React, { useMemo, useState, useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import UsersInfo from './UsersInfo';
import { UsersActions } from '../../../../Redux/modules/users/actions';
import { UsersSelectors } from '../../../../Redux/modules/users/selectors';
import { ProfileSelectors } from '../../../../Redux/modules/profile/selectors';
import { InviteMapper, StatusFilterMapper, PermissionFilterMapper, TeamsFilterMapper } from '../../constants';

function TableLayout(props) {
  const getFilteredData = () => {
    let data = props.users;
    if (props.textFilter) {
      data = data.filter((user) => {
        const fullName = `${user.first_name} ${user.last_name}`.toLowerCase();
        const userEmail = user.email.toLowerCase();
        return fullName.includes(props.textFilter.toLowerCase()) || userEmail.includes(props.textFilter.toLowerCase());
      });
    }
    if (props.permissionFilter !== PermissionFilterMapper.ALL) {
      if (props.permissionFilter === PermissionFilterMapper.SEARCH) {
        data = data.filter((user) => user.assigned_to_search);
      }
      if (props.permissionFilter === PermissionFilterMapper.ADMIN) {
        data = data.filter((user) => user.is_org_admin);
      }
    }
    if (props.statusFilter) {
      if (props.statusFilter === StatusFilterMapper.ACTIVE) {
        data = data.filter((user) => user.status.type === StatusFilterMapper.ACTIVE);
      }
      if (props.statusFilter === StatusFilterMapper.PENDING) {
        data = data.filter(
          (user) =>
            user.status.type === StatusFilterMapper.PENDING || user.status.invite_status === InviteMapper.INVITE_SENT,
        );
      }
      if (props.statusFilter === StatusFilterMapper.DECLINED) {
        data = data.filter((user) => user.status.invite_status === InviteMapper.INVITE_REJECTED);
      }
    }
    if (props.teamsFilter) {
      if (props.teamsFilter === TeamsFilterMapper.UNASSIGNED) {
        data = data.filter((user) => user.teams.length === 0);
      }
      if (props.teamsFilter !== TeamsFilterMapper.ALL && props.teamsFilter !== TeamsFilterMapper.UNASSIGNED) {
        data = data.filter((user) => user.teams.map((team) => team.name).includes(props.teamsFilter));
      }
    }
    return data;
  };
  const [filteredData, setFilteredData] = useState(getFilteredData());

  useEffect(() => {
    setFilteredData(getFilteredData());
  }, [props.teamsFilter, props.statusFilter, props.permissionFilter, props.textFilter, props.users]);

  const columns = useMemo(() => props.columns);

  return (
    <div id={props.id}>
      <UsersInfo
        isLoading={props.isLoading}
        currentLoggedEmail={props.currentLoggedEmail}
        totalAdmins={props.totalAdmins}
        totalUsers={props.totalUsers}
        currentPage={props.currentPage}
        nextPage={props.nextPage}
        previousPage={props.previousPage}
        setPage={props.setPage}
        data={filteredData}
        columns={columns}
        tableProps={props}
        usersData={props.usersData}
        fetchUsers={props.fetchUsers}
        totalInvitedUsers={props.totalInvitedUsers}
        type={props.type}
        users={props.users}
        isTrial={props.isTrial}
        actions={props.actions}
      />
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    currentLoggedEmail: ProfileSelectors.profileEmailSelector(state),
    usersData: UsersSelectors.usersDataSelector(state),
    textFilter: UsersSelectors.userFilterSelector(state),
    permissionFilter: UsersSelectors.permissionFilterSelector(state),
    statusFilter: UsersSelectors.statusFilterSelector(state),
    teamsFilter: UsersSelectors.teamsFilterSelector(state),
  };
};

const mapDispatchToProps = {
  onAdminHandle: UsersActions.adminHandle,
};

TableLayout.propTypes = {
  isLoading: PropTypes.bool,
  users: PropTypes.array,
  usersData: PropTypes.object,
  fetchUsers: PropTypes.func,
  isTrial: PropTypes.bool,

  totalUsers: PropTypes.number,
  totalAdmins: PropTypes.number,
  totalInvitedUsers: PropTypes.number,

  setPage: PropTypes.func,
  nextPage: PropTypes.func,
  previousPage: PropTypes.func,

  currentPage: PropTypes.number,
  columns: PropTypes.array,
  type: PropTypes.string,
  id: PropTypes.string,
  currentLoggedEmail: PropTypes.string,
  textFilter: PropTypes.string,
  permissionFilter: PropTypes.string,
  statusFilter: PropTypes.string,
  teamsFilter: PropTypes.string,
  actions: PropTypes.array,
};

export default connect(mapStateToProps, mapDispatchToProps)(TableLayout);
